import React from 'react';
import { BaasicTabTemplate } from 'themes/components';
import PropTypes from 'prop-types';

function BaasicTab(props) {
	return <BaasicTabTemplate {...props} />;
}

BaasicTab.propTypes = {
	field: PropTypes.object,
	className: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.array]),
	disabled: PropTypes.bool,
	disabledClassName: PropTypes.string,
	selectedClassName: PropTypes.string,
	tabIndex: PropTypes.string,
	placeholder: PropTypes.string,
};

export default BaasicTab;
